"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
// tslint:disable-next-line:variable-name
var Toast = function (props) {
    var items = props.toasts.map(function (item, index) { return (react_1.default.createElement("div", { style: { marginTop: index * 40 + "px" }, key: "toast_" + index, className: classnames_1.default("emankit__toast", props.className, item.error ? "error" : undefined) }, item.message)); });
    return react_1.default.createElement(react_1.default.Fragment, null, items);
};
exports.default = Toast;
//# sourceMappingURL=index.js.map